export default ({ pageState: { editorBlocks }, data: { blockType } }) => {
  const modifiedBlocks = { ...editorBlocks };
  for (const blockId of Object.keys(editorBlocks)) {
    const block = editorBlocks[blockId];

    if (block.isSelected || blockType === block.type) {
      modifiedBlocks[blockId] = { ...block, isSelected: true };
    }
  }

  return { editorBlocks: modifiedBlocks };
};
